var map = {
	"./card.png": 67720,
	"./card.webp": 83283,
	"./favicon.png": 2564,
	"./hans.png": 4275,
	"./hans.webp": 80664,
	"./header.png": 15729,
	"./header.webp": 60231,
	"./logo.png": 40627,
	"./logo.webp": 43875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46138;